import React from "react"
import LocationsListContainer from "@geome/shell-locator-components/lib/containers/locationsList"
import LocationsListBase from "@geome/shell-locator-components/lib/components/locationsList"
import IconAssets from "@geome/shell-locator-icons"
import { translate } from "@geome/intl"
import openGoogleDirections from "../../util/openGoogleDirections"

const LocationsList = (props) => (
  <LocationsListContainer>
    {(viewProps) => (
      <LocationsListBase
        {...viewProps}
        {...props}
        translate={translate}
        shouldShowDirectionsButton
        onDirectionsClick={openGoogleDirections}
        iconAssets={IconAssets}
      />
    )}
  </LocationsListContainer>
)

export default LocationsList
